import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Widget from "../../widget/Widget";
import TableHead from "@mui/material/TableRow";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import CancelIcon from "@mui/icons-material/Cancel";

import {
  createMuiTheme,
  ThemeProvider,
  StyledEngineProvider,
  adaptV4Theme,
} from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import MUIDataTable, { TableToolbar, TableFilterList } from "mui-datatables";
import {
  READ_WRITE_POLICY,
  DEFAULT_POLICIES,
} from "./OrganizationManagementWidgetConstants";
import CSVExporter, { CSV_TIMESTAMP_HEADERS } from "services/CSVExporter";
import QueryService from "services/QueryService";
import moment from "moment";
const EVENT_QUERY_TIME_INTERVAL_IN_DAYS = 30;
const DATE_FORMAT = "DD MMM YYYY HH:mm:ss";
const UTC_DATE_FORMAT = "dddd DD MMMM, YYYY HH:mm:ss UTC";

const AttributeTableCell = withStyles((theme) => ({
  body: {
    verticalAlign: "bottom",
    paddingLeft: 12,
    paddingRight: 12,
    "&:last-child": {
      paddingRight: 12,
    },
  },
}))(TableCell);

const tableMuiTheme = (theme) =>
  createMuiTheme(
    adaptV4Theme({
      ...theme,
      overrides: {
        ...theme.overrides,
        MuiPaper: {
          root: {
            display: "flex",
            flexFlow: "column",
            height: "100%",
          },
        },
        MUIDataTableBodyRow: {
          root: {
            "&:nth-child(even)": {
              backgroundColor: "rgb(250, 250, 250)",
            },
            cursor: "pointer",
          },
        },
        MuiTableCell: {
          root: {
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 16,
            paddingRight: 16,
          },
        },
        MuiIconButton: {
          root: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
        MuiSvgIcon: {
          root: {
            fontSize: "1em",
          },
        },
        MuiCheckbox: {
          root: {
            padding: 0,
          },
        },
      },
    })
  );

const MemoizedTable = React.memo(MUIDataTable);

const OrganizationManagementShowUserLoginsDialog = (props) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetch = async () => {
      let results;
      try {
        results = await QueryService.eventsQuery(
          props.user,
          moment
            .utc()
            .subtract(EVENT_QUERY_TIME_INTERVAL_IN_DAYS, "day")
            .valueOf(),
          0
        );
      } catch (e) {
        console.warn("get events exception", e);
        results = [];
      }
      if (results.length) {
        const entries = results[0].data.map((entry) => {
          const [timestamp, event] = entry;
          const eventCategory = event?.evcat || "User";
          const eventType = event?.evtype || "Email"; // later support other types
          const eventSource = event?.user || "Event Source";
          //const evdata = JSON.parse(event?.data || {});
          return {
            eventType: eventType,
            eventCategory: eventCategory,
            eventSource: eventSource,
            //eventData: evdata,
            eventData: event?.data || {},
            timestamp,
            /*...event,*/
          };
        });
        setData(entries);
      } else {
        setData([]);
      }
    };
    props.user && fetch();
  }, [props.user]);

  const columns = useRef([
    {
      name: "timestamp",
      label: "Timestamp",
      options: {
        // sortDirection: "desc",
        filterList: [],
        customBodyRender: (value, tableMeta, updateValue) =>
          value ? moment(value).format(DATE_FORMAT) : "---",
      },
    },
    {
      name: "eventCategory",
      label: "Category",
      options: {
        // sortDirection: "none",
        filterList: [],
        // hint: "click on a row to see evt details",
      },
    },
    {
      name: "eventType",
      label: "Type",
      options: {
        // sortDirection: "none",
        filterList: [],
        // hint: "click on a row to see evt details",
      },
    },
    {
      name: "eventSource",
      label: "Source",
      options: {
        // sortDirection: "none",
        filterList: [],
        // hint: "click on a row to see evt details",
      },
    },
    {
      name: "eventData",
      label: "Data",
      options: {
        // sortDirection: "none",
        filterList: [],
        /*customBodyRender: (value, tableMeta, updateValue) =>
          value?.tag ? value?.tag : null,*/
      },
    },
  ]);

  const closeMainDialog = () => {
    //setNewUsers([newUser()]);
    props.handleClose();
  };

  const saveCSV = () => {
    /*const rows = [].concat(
      [["username", "password", "rights", "remarks"]],
      results.map((a) => {
        return [
          a?.email,
          a?.password || "",
          a?.policies ? getPolicyName(a?.policies[0] || null) : "",
          a?.result || a?.error,
        ];
      })
    );

    const filename = "CreateUpdateUsersForOrg_" + orgName + ".csv";
    CSVExporter.export(filename, rows);*/
  };

  return (
    <Grid>
      <Dialog
        open={props.isOpen}
        onClose={closeMainDialog}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
      >
        <DialogTitle id="form-dialog-title">Recent Logins</DialogTitle>
        <DialogContent>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={tableMuiTheme}>
              <MemoizedTable
                data={data}
                columns={columns.current}
                components={{}}
                /*options={options.current}
                detailsOpen={detailsOpen} // this is to force row to highlight
                forceRender={forceRender}
                components={{
                  TableToolbar: readOnly ? ReadonlyToolbar : TableToolbar,
                  TableFilterList: readOnly
                    ? ReadonlyTableFilterList
                    : TableFilterList,
                }}*/
              />
            </ThemeProvider>
          </StyledEngineProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeMainDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default OrganizationManagementShowUserLoginsDialog;
